import store from 'store2';

const INSTRUCTIONS_KEY = 'byo.instructions';

export const hasBeenPreviouslyRead = (now) => {
  try {
    const previouslyReadDateString = store.get(INSTRUCTIONS_KEY);
    if (!previouslyReadDateString) {
      return false;
    }
    const expiration = new Date(previouslyReadDateString);
    return now < expiration;
  } catch (e) {
    return false;
  }
};

export const updateExpiration = (now) => {
  let expiration = new Date(now);
  expiration.setTime(now.getTime() + 30 * 1000);
  store.set(INSTRUCTIONS_KEY, expiration.toISOString());
};
